import { render } from "./AddProviderDialog.vue?vue&type=template&id=22839189&scoped=true"
import script from "./AddProviderDialog.vue?vue&type=script&lang=js"
export * from "./AddProviderDialog.vue?vue&type=script&lang=js"

import "./AddProviderDialog.vue?vue&type=style&index=0&id=22839189&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22839189"]])

export default __exports__